// removed by extract-text-webpack-plugin
module.exports = {"block":"_1IDbv5IlFakuAV5s2SwDsO","container":"_21lYq5CFwysQLtTYm3zQVV","heading":"_3hrjr9b5U0p9vK6kkymDHZ","shortcuts":"_2VMk1XO1RLg4yqAivR1bDo","shortcut":"_3iFZTFNesilJvlVlfJY0ds","shortcutLink":"_3y16SD8HWoh5hcYt5xmoOK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ShortcutsBlock/ShortcutsBlock.module.scss
// module id = 807
// module chunks = 0